import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Form from "@ROM-ui/Form";

import FormattedAmount from "./FormattedAmount";

const StyledTd = styled.td`
vertical-align: middle !important;
background-color: ${props => props.isTurf ? "#e3f4d9" : "#f5f5f5"} !important;
height: 50px;
`;

const ListRow = ({ warehouseInventory, onPalletsUpdate, onUnitsUpdate, editing }) => {
  const isTurf = warehouseInventory.product.categoryType.includes("Turf");

  return (
    <tr className={`text-nowrap fw-bold ${warehouseInventory.product.categoryType.includes("Turf") ? "bg-info" : ""}`}>
      <StyledTd isTurf={isTurf} className="rounded-start ps-3">{warehouseInventory.product.name}</StyledTd>
      <StyledTd isTurf={isTurf}>{warehouseInventory.product.packageUnit}</StyledTd>
      <StyledTd isTurf={isTurf} className="text-end">
        {editing ? (
          <Form.Control
            type="text"
            id={`pallets-inventory-product-${warehouseInventory.productId}`}
            value={warehouseInventory.pallets}
            onChange={(e) => onPalletsUpdate(e.target.value)}
          />
        ) : (
          <FormattedAmount>{warehouseInventory.pallets}</FormattedAmount>
        )}
      </StyledTd>
      <StyledTd isTurf={isTurf} className="text-end">
        {editing ? (
          <Form.Control
            type="text"
            id={`units-inventory-product-${warehouseInventory.productId}`}
            value={warehouseInventory.units}
            onChange={(e) => onUnitsUpdate(e.target.value)}
          />
        ) : (
          <FormattedAmount>{warehouseInventory.units}</FormattedAmount>
        )}
      </StyledTd>
      <StyledTd isTurf={isTurf} className="text-end">
        <FormattedAmount colored>{warehouseInventory.palletsLeft}</FormattedAmount>
      </StyledTd>
      <StyledTd isTurf={isTurf} className="text-end rounded-end pe-3">
        <FormattedAmount colored>{warehouseInventory.unitsLeft}</FormattedAmount>
      </StyledTd>
    </tr>
  );
};

ListRow.propTypes = {
  warehouseInventory: PropTypes.shape().isRequired,
  editing: PropTypes.bool.isRequired,
  onPalletsUpdate: PropTypes.func.isRequired,
  onUnitsUpdate: PropTypes.func.isRequired,
};

export default ListRow;
